import { lazy } from "react";

const HomeRoutes = [
  {
    path: "/home",
    component: lazy(() => import("../../views/dashboard/summary")),
    title: "Home",
  },
  // {
  //   path: "/home",
  //   component: lazy(() => import("../../views/home")),
  //   title: "Home",
  // },
];

export default HomeRoutes;
